export default "__VITE_ASSET__CBDjtsfI__"